module.exports = __webpack_public_path__ + "img/news.88172495.png";